export interface IMessage {
	id: number;
	role: 'user' | 'ai';
	text: string;
	time?: string;
	mode?: IMode;
}

export type IMode = 'conversation' | 'agent' | 'doc_qa';

export type FormType = 'sales_invoice' | 'purchase_invoice';

export const FORM_TYPE_LABELS: Record<FormType, string> = {
  sales_invoice: 'Sales Invoice',
  purchase_invoice: 'Purchase Invoice',
};

export type InsightKind = 'red' | 'amber' | 'blue' | '';

export type DocumentStatus = 'uploading' | 'pending' | 'processing' | 'parsing' | 'embedding' | 'indexing' | 'ready' | 'failed';

export interface IDocument {
  doc_id: string;
  filename: string;
  status: DocumentStatus;
  pages?: number;
  category?: string;
  sub_category?: string;
  chunk_count?: number;
  error?: string;
  error_code?: string;
  summary?: string;
  suggested_questions?: string[];
}

export type FileCategory = 'pdf' | 'excel' | 'doc' | 'md' | 'image';

export const ACCEPTED_FILE_EXTENSIONS: Record<FileCategory, string[]> = {
  pdf: ['.pdf'],
  excel: ['.xls', '.xlsx'],
  doc: ['.doc', '.docx'],
  md: ['.md'],
  image: ['.png', '.jpg', '.jpeg'],
};

export const ACCEPT_ATTR = Object.values(ACCEPTED_FILE_EXTENSIONS).flat().join(',');

export const getFileCategory = (filename: string): FileCategory | null => {
  const lower = filename.toLowerCase();
  return (Object.keys(ACCEPTED_FILE_EXTENSIONS) as FileCategory[]).find((category) =>
    ACCEPTED_FILE_EXTENSIONS[category].some((ext) => lower.endsWith(ext))
  ) || null;
};

export const getTime = () =>
	new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

export const getGreeting = () => {
	const h = new Date().getHours();
	if (h < 12) return 'Good morning';
	if (h < 17) return 'Good afternoon';
	return 'Good evening';
};
